// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__19Xuk","col":"CardReaderDesc_col__3v2pG","label":"CardReaderDesc_label__3S0A0"};